import { TenantCreatorHeaderCell } from '../components/TenantsTable/TenantCreatorHeaderCell';
import { TENANT_COLUMN } from '../helpers/constants';
import tableStyles from '../../../components/Table/index.module.scss';

export const useTenantCreatorColumn = () => ({
  width: 207,
  dataIndex: TENANT_COLUMN.CREATED_BY,
  title: <TenantCreatorHeaderCell className={tableStyles.hiddenHeaderCell} />,
});
